import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

import AppRoutes from './app/components/Routes';
import AppInitializer from './app/components/Initializer';
import AppRoot from './app/components/AppRoot';
import ToastContainer from './app/components/ToastContainer';

import i18n from './config/i18n';

import Store from './redux/store';

function App() {
  return (
    <Provider store={Store}>
      <I18nextProvider i18n={i18n}>
        <AppRoot>
          <AppInitializer>
            <AppRoutes />
          </AppInitializer>
          <ToastContainer />
        </AppRoot>
      </I18nextProvider>
    </Provider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js